import { render, staticRenderFns } from "./SalesEdit_Total.vue?vue&type=template&id=52675244&"
import script from "./SalesEdit_Total.vue?vue&type=script&lang=js&"
export * from "./SalesEdit_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports